"use client"

export default function GlobalError() {
    return (
        <div>Global Error</div>
    )
}